import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import Heading from '@tds/core-heading';
import Spinner from '@tds/core-spinner';

import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import request from '../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../design/css';
import { getPathVariables } from '../misc';
import { quoteStatus } from '../utils/constant';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

import Table from './Table';

const QuoteApprovalDashboard = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    quoteApprovalDashboard: {
      noQuoteMessage,
      loadingQuotesMessage,
      tableTitleDefault
    }
  } = localizedStrings;
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'quoteApprovalDashboard',
    locale
  };

  const [pageLayout, setPageLayout] = useState();
  const [pendingApprovalOrders, setPendingApprovalOrders] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    getContentfulData(config).then(res => {
      setPageLayout(getData(res));
      request
        .get(`/orders?quoteStatus=${quoteStatus.pendingApproval}`)
        .then(response => {
          setPendingApprovalOrders(_.get(response, 'data.results', []));
          setPageLoading(false);
        })
        .catch(() => {});
    });
  }, []);

  const removeQuoteFromList = orderID => {
    const newPendingApprovalOrders = pendingApprovalOrders.filter(
      order => order.id !== orderID
    );
    setPendingApprovalOrders(newPendingApprovalOrders);
  };

  return (
    <>
      <Spinner label={loadingQuotesMessage} spinning={pageLoading}>
        <ContentWrapper style={{ padding: '0 4rem' }}>
          {pendingApprovalOrders.length === 0 ? (
            <Heading level="h3">{noQuoteMessage}</Heading>
          ) : (
            <Box
              style={{
                margin: '2rem 0',
                border: '1px solid #e3e3e3',
                boxShadow: '1px 1px 9px 4px #e3e3e3'
              }}
            >
              <TopbarWrapper style={{ color: '#fff' }}>
                {`${_.get(pageLayout, 'tableTitle', tableTitleDefault)} (${
                  pendingApprovalOrders.length
                })`}
              </TopbarWrapper>
              <Table
                pageLayout={pageLayout}
                data={pendingApprovalOrders}
                removeData={removeQuoteFromList}
              />
            </Box>
          )}
        </ContentWrapper>
      </Spinner>
    </>
  );
};

export default QuoteApprovalDashboard;
